import {
  PoseLandmarker,
  FilesetResolver,
  // HandLandmarker,
} from '@mediapipe/tasks-vision';
// import { Exercises, version } from "../../constants/constants";
import { exercisesStats } from '../../reducers/exercises-reducer';
import { exerciseType, executionMode } from '../../constants/constants';
import { ENV } from '@config/env';
import { SERVER_BASE_URL } from '../../constants/domain';
import { stopCamera } from '../../services/camera-manager';
import { getTimer } from '../../utilis/helpers';
import tw from 'twin.macro';

export const initializePoseLandmark = async ({
  addPoseLandMarker,
  // addHandPoseLandMarker,
  // setDetectModel,
}) => {
  try {
    // get modal from file
    const vision = await FilesetResolver.forVisionTasks(
      // "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.0/wasm"
      ENV.isLocal ? '/wasm' : `${SERVER_BASE_URL}/wasm`
    );
    // // prepare poseLandmarker and get object by createFromOptions faction
    const poseLandmarker = await PoseLandmarker.createFromOptions(vision, {
      baseOptions: {
        modelAssetPath:
          // "https://storage.googleapis.com/mediapipe-models/pose_landmarker/pose_landmarker_heavy/float16/1/pose_landmarker_heavy.task",
          ENV.isLocal
            ? '/models/pose_landmarker_heavy.task'
            : `${SERVER_BASE_URL}/models/pose_landmarker_heavy.task`,
        // "/public/models/pose_landmarker_heavy.task",
        delegate: 'GPU',
      },
      // runningMode: "VIDEO",
      runningMode: 'VIDEO',
      // number of person for detect
      numPoses: 1,
      minPoseDetectionConfidence: 0.9,
      minTrackingConfidence: 0.9,
      minPosePresenceConfidence: 0.9,
      outputSegmentationMasks: false,
    });

    // this code for get poseLandmark and put to state
    addPoseLandMarker(poseLandmarker);
    // addHandPoseLandMarker(handPoseLandMarker);
  } catch (error) {
    console.log(error);
  }
};

export const handleToggleTimerStatue = (inPerformance, connectionStatus, TotalStart, totalPush) => {
  // start or pause timer depend on stage
  if (inPerformance && connectionStatus !== 'Closed') {
    TotalStart();
  } else {
    totalPush();
  }
};

export const handleSetPersonSoundPlaySound = ({
  voice,
  setIsPlaying,
  setCurrentVoiceIndex,
  stopVoice,
  audioDevice,
}) => {
  const handlePlay = () => {
    setIsPlaying(true);
    setCurrentVoiceIndex(0);
  };

  const handleEnded = () => {
    setIsPlaying(false);
    localStorage.setItem('isPlaySound', 1);
    setCurrentVoiceIndex(-1);
  };

  const handleError = error => {
    console.error('Error:', error);
    setIsPlaying(false);
  };

  // Store audio reference to control it when visibility changes
  let audioElement = null;

  // Handle visibility change
  const handleVisibilityChange = () => {
    if (!audioElement) {
      return;
    }

    if (document.visibilityState === 'hidden') {
      // Page is not visible, pause audio
      audioElement.pause();
      setIsPlaying(false);
    } else if (document.visibilityState === 'visible') {
      // Page is visible again and sound was playing, resume audio
      const audioPromise = audioElement.play();

      if (audioPromise !== undefined) {
        audioPromise.catch(error => {
          console.error('Error resuming audio:', error);
        });
      }
    }
  };

  fetch(`${voice}`)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.blob();
    })
    .then(blob => {
      const audio = new Audio(URL.createObjectURL(blob));
      audioElement = audio;

      // Add visibility change listener
      document.addEventListener('visibilitychange', handleVisibilityChange);

      const handleTimeUpdate = () => {
        localStorage.setItem('audio_time', audio.currentTime);
      };

      // Remove any existing event listeners before adding new ones
      audio.removeEventListener('play', handlePlay);
      audio.removeEventListener('ended', handleEnded);
      audio.removeEventListener('timeupdate', handleTimeUpdate);

      audio.addEventListener('play', handlePlay);
      audio.addEventListener('ended', () => {
        handleEnded();

        // Clean up visibility change listener when audio ends
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      });
      audio.addEventListener('timeupdate', handleTimeUpdate);

      // Check if document is already hidden before playing
      if (document.visibilityState === 'hidden') {
        return; // Don't play if browser window is not visible
      }

      if (audioDevice) {
        audio
          .setSinkId(audioDevice)
          .then(() => {
            console.log(`Audio output device set to ${audioDevice}`);
            if (!stopVoice) {
              audio.pause();
            }
            const audioPromise = audio.play();
            if (audioPromise !== undefined) {
              audioPromise
                .then(() => {
                  // Autoplay started
                })
                .catch(error => {
                  console.error('Error playing sound:', error);
                });
            }
          })
          .catch(error => {
            console.error(`Error setting audio output device: ${error}`);
            handleError(error); // Handle errors from setSinkId
          });
      } else {
        if (!stopVoice) {
          audio.pause();
        }
        const audioPromise = audio.play();
        audio.muted = true;
        if (audioPromise !== undefined) {
          audioPromise
            .then(() => {
              // Autoplay started
            })
            .catch(error => {
              console.error('Error playing sound:', error);
            });
        }
      }
    })
    .catch(error => {
      console.error('Error fetching sound file:', error);
      handleError(error); // Handle errors from fetch
    });
};

export const handlePlayFeedbackVoice = (feedbackSound, setIsPlayingSound, setCurrentVoiceIndex) => {
  if (feedbackSound) {
    // for play locally feedback voice depend on text and index of array
    fetch(`${feedbackSound?.instruction?.voice}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.blob();
      })
      .then(blob => {
        const audio = new Audio(URL.createObjectURL(blob));
        audio.addEventListener('play', () => {
          setIsPlayingSound(true);
          setCurrentVoiceIndex(0);
        });

        audio.addEventListener('ended', () => {
          setIsPlayingSound(false);
          setCurrentVoiceIndex(-1);
        });

        const audioPromise = audio.play();
        if (audioPromise !== undefined) {
          audioPromise
            .then(() => {
              // Autoplay started
              // console.log("Autoplay started");
            })
            .catch(error => {
              console.error('Error playing sound:', error);
            });
        }
      })
      .catch(error => {
        console.error('Error fetching sound file:', error);
      });
  }
};

export const handleGetPostPerformance = ({
  postPerformance,
  parseInitialMovement,
  Exercises,
  postData,
  isPlayModal,
  navigate,
  totalMinutes,
  totalSeconds,
  dispatch,
}) => {
  if (!postPerformance) {
    return;
  }

  // Helper function to create data objects
  const createDataToSend = extraData => ({
    isPlayingSound: isPlayModal,
    time: { minutes: totalMinutes, seconds: totalSeconds },
    ...extraData,
  });

  const { movement } = parseInitialMovement;
  const movementLower = movement.toLocaleLowerCase();

  if (movementLower === Exercises.WallClimbShoulderFlexion.toLocaleLowerCase()) {
    const dataToSend = createDataToSend({
      angle: postData?.angle,
      charts: postData?.chart,
    });

    const queryString = encodeURIComponent(JSON.stringify(dataToSend));
    navigate(`/call-climb-post?values=${queryString}`);
    if (dispatch) {
      dispatch({ type: exercisesStats.showPost, payload: true });
    }
  } else if (
    [Exercises.shutdown, Exercises.spongebob].some(
      exercise => movementLower === exercise.toLocaleLowerCase()
    )
  ) {
    const dataToSend = createDataToSend({
      counter: postData?.repetition,
      percentage: postData?.accuracy,
      stars: postData?.stars,
    });

    const queryString = JSON.stringify(dataToSend);
    navigate(`/dance-post?data=${queryString}`);
  } else {
    const dataToSend = createDataToSend({
      counter: postData?.repetition,
      percentage: postData?.accuracy,
      stars: postData?.stars,
    });

    const queryString = JSON.stringify(dataToSend);
    navigate(`/post-performance?data=${queryString}`);
  }

  // Store total duration in localStorage
  localStorage.setItem('duration', totalMinutes + totalSeconds);
};

// Function to handle audio play
export const handlePlaySountTick = audioRef => {
  const audio = audioRef?.current;
  if (audio) {
    audio.pause(); // Pause if it's playing
    audio.currentTime = 0; // Reset to start
    audio.play().catch(e => {
      // Optional: handle autoplay policy restrictions
      console.error('Audio play failed:', e);
    });
  }
  if (audioRef.current) {
    // Only play if the document is visible
    if (document.visibilityState === 'visible') {
      // Check if the audio is already playing
      if (audioRef.current.paused) {
        audioRef.current.play().catch(error => {
          console.error('Error playing sound:', error);
        });

        // Add visibility change listener to pause audio when tab loses focus
        const handleVisChange = () => {
          if (document.visibilityState === 'hidden' && audioRef.current) {
            audioRef.current.pause();
          } else if (
            document.visibilityState === 'visible' &&
            audioRef.current &&
            audioRef.current.paused
          ) {
            audioRef.current.play().catch(err => console.error('Error resuming audio:', err));
          }
        };

        // Add event listener
        document.addEventListener('visibilitychange', handleVisChange);

        // Remove event listener when audio ends
        audioRef.current.addEventListener(
          'ended',
          () => {
            document.removeEventListener('visibilitychange', handleVisChange);
          },
          { once: true }
        );
      }
    }
  }
};

export const getVideoUrl = () => {
  const VideoFromLocalStorage = localStorage.getItem('video-url');
  return VideoFromLocalStorage;
};

// Called both from the exercise page (with the video ref and dispatch on hand)
// and from the socket's 4401 close handler, which only has the ref — so every
// argument is optional and the hardware release below always runs.
export const cleanupStream = ({ videRef, dispatch } = {}) => {
  if (videRef) {
    videRef.current = null;
  }
  if (dispatch) {
    dispatch({ type: exercisesStats.cameraIsActive, payload: false });
  }
  // The MediaStream itself is owned by CameraManager, not by reducer state —
  // stopCamera() releases the hardware directly instead of reaching into
  // state.streamRef for tracks to stop.
  stopCamera('exercise-cleanup');
};

export const handleRemoveFromLocalForage = () => {
  //  remove database that has video from localforage
  // localforage.setDriver(localforage.INDEXEDDB).then(() => {
  //   const dbName = localforage.config().name || "localforage";
  //   const request = indexedDB.deleteDatabase(dbName);
  //   request.onsuccess = function () {
  //     console.log(`Database '${dbName}' successfully deleted.`);
  //   };
  //   request.onerror = function (event) {
  //     console.error("Error deleting database:", event.target.error);
  //   };
  // });
};

// export const hideCounter = ({ movementName }) => {
//   // hide counter component when type of exercises is fixed reps and fixed time
//   const isHidden =
//     movementName?.toLowerCase() === Exercises.yoga.toLowerCase() ||
//     movementName?.toLowerCase() === Exercises.shutdown.toLowerCase() ||
//     movementName?.toLowerCase() === Exercises.spongebob.toLowerCase() ||
//     movementName?.toLowerCase() === Exercises.Plank.toLowerCase();
//   return { isHidden };
// };

/**
 * Pixel geometry of the frame MediaPipe is actually reading, sent to the backend
 * as `frameWidth` / `frameHeight`.
 *
 * Every media source hangs off the same `videoRef` shape — `{ video, stream }`,
 * assigned by hand in WebcamAndSkeltonSide for the live camera branch (fed by
 * CameraManager) as well as the uploaded-clip branch. The ref itself is
 * therefore never the element — reading `videoRef.current.videoWidth` yields
 * undefined.
 *
 * The track-settings fallback covers a <video> that hasn't painted its first
 * frame yet, so `videoWidth` is still 0 while the camera already reports its
 * negotiated resolution. Returns `{}` when neither source knows, so spreading it
 * into a payload simply omits the keys and lets the backend keep its defaults.
 */
export const resolveFrameGeometry = videoRef => {
  const videoElement = videoRef?.current?.video;
  const trackSettings = videoRef?.current?.stream?.getVideoTracks?.()[0]?.getSettings?.();

  const frameWidth = videoElement?.videoWidth || trackSettings?.width || undefined;
  const frameHeight = videoElement?.videoHeight || trackSettings?.height || undefined;

  if (!frameWidth || !frameHeight) {
    return {};
  }

  return { frameWidth, frameHeight };
};

export const getCounterBackground = isFalseStage => {
  // set red background for cutdown timer for specific conditions
  return isFalseStage ? tw`bg-[rgba(255,0,0,0.5)]` : tw`bg-[rgba(24,24,24,0.5)]`;
};

export const loadVideoFromIndexedDB = async ({
  durationAfterFilter,
  postChunks,
  videoElement, // Pass in the video element to control playback
}) => {
  try {
    // Retrieve necessary values from local storage
    const frontEenTimer = localStorage.getItem('frontend_timer');

    // Set the new custom duration based on the isFullTime flag
    const newDuration = Math.floor(Number(frontEenTimer)) * 1000;
    // : Math.floor(Number(frontEenTimer) - Number(fullTime)) * 1000; // Convert to milliseconds if needed
    let blob = null;
    // Fetch the video blob from IndexedDB
    // const blobFromIndexedDB = await localforage.getItem("recordedVideo");
    if (postChunks?.length > 0) {
      console.log('from local');
      blob = new Blob(postChunks, {
        type: 'video/webm; codecs=vp8',
      });
    } else {
      console.log('from index db');
      // blob = new Blob(blobFromIndexedDB, {
      //   type: "video/webm; codecs=vp8",
      // });
    }
    // Create a Blob from the retrieved data

    let fixedBlob;

    // Use durationAfterFilter if available, otherwise use the calculated newDuration
    // if (durationAfterFilter) {
    //   fixedBlob = await fixWebmDuration(blob, durationAfterFilter * 1000); // Convert durationAfterFilter to milliseconds
    // } else {
    //   fixedBlob = await fixWebmDuration(blob, newDuration);
    // }

    // Generate a URL for the video
    const videoUrl = URL.createObjectURL(fixedBlob);

    // If a video element is provided, set the source and start playing
    if (videoElement) {
      videoElement.src = videoUrl;
      videoElement.play();
    }

    return videoUrl;
  } catch (err) {
    console.error('Failed to load video from IndexedDB', err);
  }
};

export const reInitializeRecord = ({ videoRef, prePerformance, setMediaRecorder }) => {
  if (videoRef?.current?.stream && !prePerformance) {
    const recorder = new MediaRecorder(videoRef.current.stream, {
      mimeType: 'video/webm',
    });
    if (recorder) {
      setMediaRecorder(recorder);
    }
  }
};

function getHands(results) {
  // get from model left and right hands and return the values
  let leftHand = null;
  let rightHand = null;
  for (let i = 0; i < results.handedness.length; i++) {
    const handLandmarks = results.landmarks[i];
    const handedness = results.handedness[i];

    const label = handedness[0].displayName;
    if (label === 'Right' && !rightHand) {
      rightHand = handLandmarks;
    } else if (label === 'Left' && !leftHand) {
      leftHand = handLandmarks;
    }

    if (rightHand && leftHand) {
      break;
    }
  }
  // swap left and right because media pipe return self mode
  return swap(rightHand, leftHand);
}
function detectBoundingBoxRegion(handsList, height, width) {
  // return pounding box for hands
  let xs = [];
  let ys = [];

  // Extract x and y coordinates from hand landmarks
  handsList.forEach(hand => {
    hand.forEach(l => {
      xs.push(l.x);
      ys.push(l.y);
    });
  });

  let margin = 20;
  let xMinBox = Math.floor(Math.min(...xs) * width) - margin;
  let yMinBox = Math.floor(Math.min(...ys) * height) - margin;
  let xMaxBox = Math.ceil(Math.max(...xs) * width) + margin;
  let yMaxBox = Math.ceil(Math.max(...ys) * height) + margin;

  // Clip bounding box to ensure it's within frame limits
  return clipBBox({
    xMinBox,
    xMaxBox,
    yMinBox,
    yMaxBox,
    height,
    width,
  });
}
function clipBBox({ xMinBox, xMaxBox, yMinBox, yMaxBox, height, width }) {
  return {
    xMinBox: Math.max(0, Math.min(xMinBox, width - 1)),
    xMaxBox: Math.max(0, Math.min(xMaxBox, width - 1)),
    yMinBox: Math.max(0, Math.min(yMinBox, height - 1)),
    yMaxBox: Math.max(0, Math.min(yMaxBox, height - 1)),
  };
}

function swap(leftHand, rightHand) {
  return { rightHand, leftHand };
}
export const getPBox = (results, W, H) => {
  let { rightHand, leftHand } = getHands(results);
  let x = 0;
  let y = 0;
  let width = W;
  let height = H;
  if (rightHand && leftHand) {
    // Detect bounding box region
    const { yMinBox, yMaxBox, xMinBox, xMaxBox } = detectBoundingBoxRegion(
      [rightHand, leftHand],
      H,
      W
    );

    let boxH = yMaxBox - yMinBox;
    let boxW = xMaxBox - xMinBox;
    let halfBoxSize = Math.floor(Math.max(boxH, boxW) / 2);
    let centerX = Math.floor((xMaxBox + xMinBox) / 2);
    let centerY = Math.floor((yMaxBox + yMinBox) / 2);

    let newXMinBox = centerX - halfBoxSize;
    let newXMaxBox = centerX + halfBoxSize;
    let newYMinBox = centerY - halfBoxSize;
    let newYMaxBox = centerY + halfBoxSize;

    // Clip bounding box to ensure it stays within frame bounds
    const obj = clipBBox({
      xMinBox: newXMinBox,
      xMaxBox: newXMaxBox,
      yMinBox: newYMinBox,
      yMaxBox: newYMaxBox,
      height: H,
      width: W,
    });
    x = obj.xMinBox;
    y = obj.yMinBox;
    width = obj.xMaxBox - obj.xMinBox;
    height = obj.yMaxBox - obj.yMinBox;
  }
  return { x, y, width, height };
};

export const getExpireTime = ({ durationInSeconds }) => {
  const currentTime = new Date();
  const expiryTimestamp = durationInSeconds
    ? new Date(currentTime.getTime() + durationInSeconds * 1000)
    : new Date(currentTime.getTime() + 30 * 1000);
  return { expiryTimestamp };
};

export const inputAndOutputDetectionModel = ({
  modelRef,
  busy,
  imageData,
  movementName,
  outputModel,
}) => {
  if (modelRef.current && !busy.current) {
    busy.current = true;
    modelRef.current.postMessage({
      imageData,
      delay: movementName === Exercises.ballWallSquat ? 70 : 0,
      movementName,
      time: performance.now(),
    });
    modelRef.current.onmessage = event => {
      busy.current = false;

      if (event.data.boxes) {
        outputModel.current = event.data.boxes;
      } else {
        outputModel.current = event.data.className;
      }
    };
  }
};

export const fingerTuttingDraw = ({
  canvasObject,
  result,
  canvasRef,
  contextObject,
  busy,
  modelRef,
  outputModel,
  movementName,
}) => {
  if (!canvasObject || !canvasRef) {
    return;
  }

  canvasObject.width = 456;
  canvasObject.height = 456;
  const { x, y, width, height } = getPBox(
    result,
    canvasRef.current.width,
    canvasRef.current.height
  );

  contextObject.drawImage(canvasRef.current, x, y, width, height, 0, 0, 456, 456);

  const imageData = contextObject.getImageData(0, 0, 456, 456);
  inputAndOutputDetectionModel({
    busy,
    imageData,
    modelRef,
    movementName: movementName,
    outputModel: outputModel,
  });
};

export const ballWallSquatDraw = ({
  canvasObject,
  canvasRef,
  contextObject,
  busy,
  modelRef,
  outputModel,
  movementName,
  crop,
}) => {
  if (!canvasObject || !canvasRef) {
    return;
  }

  canvasObject.width = 640;
  canvasObject.height = 640;
  contextObject.clearRect(0, 0, 640, 640);

  const sourceWidth = canvasRef.current.width;
  const sourceHeight = canvasRef.current.height;

  // Calculate scale to fit width or height
  const mutsToResize = Math.min(crop, 0);

  contextObject.drawImage(
    canvasRef.current,
    -mutsToResize,
    0,
    sourceWidth + 2 * mutsToResize,
    sourceHeight,
    0,
    0,
    640,
    640
  );
  const imageData = contextObject.getImageData(0, 0, 640, 640);
  inputAndOutputDetectionModel({
    busy,
    imageData,
    modelRef,
    movementName: movementName,
    outputModel: outputModel,
  });
};

export const resolveScoreStyles = score => {
  if (score === null || score === undefined) {
    return tw`bg-[rgba(15,23,42,0.78)] border-[#94A3B8] text-white`;
  }

  if (score < 40) {
    return tw`bg-[rgba(153,27,27,0.88)] border-[#FCA5A5] text-white`;
  }

  if (score < 70) {
    return tw`bg-[rgba(180,83,9,0.9)] border-[#FCD34D] text-[#FFF7ED]`;
  }

  return tw`bg-[rgba(22,101,52,0.9)] border-[#86EFAC] text-[#F0FDF4]`;
};

export const convertStoMs = seconds => {
  let minutes = ~~(seconds / 60);
  let extraSeconds = seconds % 60;
  return `${minutes < 10 ? `0${minutes}` : minutes}:${
    extraSeconds < 10 ? `0${extraSeconds}` : extraSeconds
  }`;
};

// Tokens arrive exactly as the backend spells them (REP_BASED / TIMED_REPS /
// TIMED_HOLD), but a stripped comparison costs nothing and keeps a stray
// lower-case payload from silently falling back to the wrong readouts.
const normalizeToken = value =>
  String(value ?? '')
    .replace(/[\s_-]+/g, '')
    .toLowerCase();

const EXERCISE_TYPE_TOKENS = {
  repbased: exerciseType.repBased,
  timedreps: exerciseType.timedReps,
  timedhold: exerciseType.timedHold,
};

const EXERCISE_TYPE_STORAGE_KEY = 'exerciseType';

/**
 * Reads `type` off a stage payload (introResult / setResult / pauseStage entry).
 * Returns null when the payload doesn't state one. The retired keys
 * (`exercise_mode`, `exerciseMode`, `mode`) are not consulted — the backend does
 * not send them any more.
 */
export const resolveExerciseType = source => {
  if (!source || typeof source !== 'object') {
    return null;
  }

  return EXERCISE_TYPE_TOKENS[normalizeToken(source.type)] ?? null;
};

/**
 * Reads `execution_mode` off a stage payload or a frame. Defaults to motion
 * capture, which is also the backend's default for a prescription entry.
 */
export const resolveExecutionMode = source => {
  const token = normalizeToken(source?.execution_mode);
  if (token === 'nomotioncapture') {
    return executionMode.noMotionCapture;
  }
  if (token === 'motioncapture') {
    return executionMode.motionCapture;
  }
  return null;
};

export const isMotionCaptureMode = value =>
  resolveExecutionMode(value) !== executionMode.noMotionCapture;

// The intro payload states the type once per exercise, but the page can re-read
// it much later (remount after a camera error, socket reconnect), so it is
// mirrored to localStorage. Writing null clears the key instead of leaving the
// previous exercise's value behind for the next one to inherit.
export const persistExerciseType = value => {
  try {
    if (value) {
      localStorage.setItem(EXERCISE_TYPE_STORAGE_KEY, value);
    } else {
      localStorage.removeItem(EXERCISE_TYPE_STORAGE_KEY);
    }
  } catch (error) {
    console.error('Failed to persist the exercise type:', error);
  }
};

export const readStoredExerciseType = () => {
  try {
    const stored = localStorage.getItem(EXERCISE_TYPE_STORAGE_KEY);
    return Object.values(exerciseType).includes(stored) ? stored : null;
  } catch (error) {
    console.error('Failed to read the stored exercise type:', error);
    return null;
  }
};

/**
 * Which live readouts an exercise calls for, derived from `type` alone. Shared
 * between the desktop overlay pills (video-and-comment-side) and the
 * portrait-mobile stat bar so the two can't disagree.
 *
 * A TIMED_HOLD carries no `counter` on the frame at all — the hold is the set —
 * so it shows the timer only. REP_BASED shows its counter regardless of camera
 * state — offline it falls back to the prescribed target (see totalReps at the
 * call site) rather than a live count, but that target is still the metric the
 * user is working against.
 *
 * REP_BASED shows no timer at all. The set ends on the reps, so the countdown
 * is not the metric the user is working against — it stays off in every layout
 * (desktop overlay, portrait stat bar, landscape cards) and offline too, where
 * there is still no clock deciding the set.
 *
 * TIMED_REPS is the one type that flips with offline: online it has an open
 * rep counter (time ends the set, not a rep target), but offline nothing is
 * counting reps at all — there is no target to fall back to either — so the
 * counter has nothing to show and the countdown becomes the only live readout.
 */
export const resolveExerciseReadoutFlags = (type, { isOffline = false } = {}) => {
  const resolvedType = EXERCISE_TYPE_TOKENS[normalizeToken(type)] ?? exerciseType.repBased;
  const isTimedHold = resolvedType === exerciseType.timedHold;
  const isRepBased = resolvedType === exerciseType.repBased;
  const isTimedReps = resolvedType === exerciseType.timedReps;

  return {
    type: resolvedType,
    isTimedHold,
    isRepBased,
    isTimedReps,
    showsCounter: isRepBased || (isTimedReps && !isOffline),
    showsTimer: !isRepBased,
  };
};

/**
 * Who owns the exercise clock: every type (TIMED_HOLD, TIMED_REPS, REP_BASED
 * alike) follows the same backend gate. userTimer and eft-time both run only
 * while the frame's `holdTimerPaused` and the matcher's copy of it report
 * false (resolveHoldTimerRunning); anything else stops them.
 *
 * Offline overrides it. Nothing is being scored — no pose, no reps, and the
 * backend never raises `holdTimerPaused` without motion capture — so the
 * countdown is pure time, shows for every type, and runs to the end on its own.
 */
export const TIMER_FREEZE_POLICY = Object.freeze({
  backend: 'backend',
  never: 'never',
});

export const resolveTimerFreezePolicy = (type, { isOffline = false } = {}) => {
  return isOffline ? TIMER_FREEZE_POLICY.never : TIMER_FREEZE_POLICY.backend;
};

/**
 * The wall clock: session time the patient's own performance cannot freeze, sent
 * to the backend as `wallEft` and anchored per socket.
 *
 * Deliberately NOT `eft-time`'s twin. `eft-time` stops whenever the backend raises
 * `holdTimerPaused` (quality under threshold, out of frame), which is what makes a
 * hold set stall; this one keeps running through all of that, so the backend can
 * cap a set the patient cannot complete. Only two things hold it: a genuine
 * suspension (resolveSessionSuspended) and the get-ready "3, 2, 1", which it sits
 * out alongside eft-time — nobody is performing yet.
 */
export const SESSION_WALL_TIMER_KEY = 'session-wall-time';

/**
 * Whether the session is genuinely suspended — one of the two things that hold the
 * wall clock (the get-ready "3, 2, 1" is the other, handled at the call site). The
 * quality gate and a restart/skip are deliberately absent: neither stops the session.
 * A down remote pose link is one: nothing can be scored until its results return.
 */
export const resolveSessionSuspended = ({
  openSettingModel = false,
  isPauseStage = false,
  isCameraInfoOpen = false,
  isPoseLinkDown = false,
} = {}) => Boolean(openSettingModel || isPauseStage || isCameraInfoOpen || isPoseLinkDown);

const SET_CEILING_STORAGE_KEY = 'setCeilingSeconds';

/**
 * The set's wall-clock ceiling, stated on the intro payload as
 * `set_ceiling_seconds`: the seconds after which the backend ends a TIMED_HOLD
 * set for the patient, whether or not they ever reached the quality threshold
 * (see `_ceiling_reached` in base_pose_evaluator). Twice the prescribed eta, so
 * a 3x30s plank caps each set at 60s.
 *
 * Null on every other type — the backend sends none — and on a payload that
 * omits it, which is what hides the readout rather than showing a zeroed clock.
 */
export const resolveSetCeilingSeconds = source => {
  if (!source || typeof source !== 'object') {
    return null;
  }

  const seconds = Number(source.set_ceiling_seconds);
  return Number.isFinite(seconds) && seconds > 0 ? seconds : null;
};

// Mirrored for the same reason the exercise type is (see persistExerciseType): the
// intro payload states it once per exercise and a remount/reconnect mid-set must
// not lose it. Writing null clears the key so the next exercise cannot inherit it.
export const persistSetCeilingSeconds = value => {
  try {
    if (value) {
      localStorage.setItem(SET_CEILING_STORAGE_KEY, String(value));
    } else {
      localStorage.removeItem(SET_CEILING_STORAGE_KEY);
    }
  } catch (error) {
    console.error('Failed to persist the set ceiling:', error);
  }
};

export const readStoredSetCeilingSeconds = () => {
  try {
    const seconds = Number(localStorage.getItem(SET_CEILING_STORAGE_KEY));
    return Number.isFinite(seconds) && seconds > 0 ? seconds : null;
  } catch (error) {
    console.error('Failed to read the stored set ceiling:', error);
    return null;
  }
};

/**
 * The ceiling countdown, as "MM:SS" — what the patient watches at the top centre
 * while a TIMED_HOLD set runs.
 *
 * Read off the wall clock (SESSION_WALL_TIMER_KEY), NOT off userTimer/eft-time:
 * that is the whole point of it. The set countdown freezes whenever the backend
 * raises `holdTimerPaused` (quality under the threshold, red frame, out of
 * frame), so a patient who never holds the position cleanly can sit on a set
 * forever; this one keeps running through all of that and only stops where the
 * wall clock itself stops — a genuine suspension (the pause modal) and the
 * get-ready "3, 2, 1".
 *
 * `anchorMs` is the wall reading banked when the set started, mirroring the
 * backend's own `wall_eft_offset`, so the countdown is per set rather than per
 * socket. Before it exists there is nothing to count from: show the full
 * ceiling rather than a clock that reads as already spent.
 */
export const resolveRemainingSetCeilingTime = ({ time, ceilingSeconds, anchorMs }) => {
  const totalSeconds = Number(ceilingSeconds);

  if (!Number.isFinite(totalSeconds) || totalSeconds <= 0) {
    return null;
  }

  if (!Number.isFinite(anchorMs)) {
    return convertStoMs(Math.round(totalSeconds));
  }

  const elapsed = getTimer({ key: SESSION_WALL_TIMER_KEY, timer: time }) - anchorMs;
  const remaining = totalSeconds * 1000 - Math.max(0, elapsed);

  return convertStoMs(remaining > 0 ? Math.ceil(remaining / 1000) : 0);
};
